import * as types from "./actionTypes";

export const setNewInstallByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_NEW_INSTALL_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setNewInstallByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_NEW_INSTALL_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceNewInstallYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_NEW_INSTALL_YEARS,
      key,
      payload,
    });
  };
};

export const resetNewInstallReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_NEW_INSTALL_REDUCER,
    });
  };
};
